import React from 'react'

const Paddyimage = () => {
  return (
    <div>
      
    </div>
  )
}

export default Paddyimage
